import { SDK } from './helpers/sdk';
import { PublicLinkMask } from './masks/public-link.mask';
import type { Link } from '@sda/interfaces/link';
import type { FirestoreClientData } from './interfaces';

/**
 * SDK Class to interact with the Links collection
 */
export class Links extends SDK<Link> {
  constructor(apiClient: FirestoreClientData) {
    super(apiClient);

    this.collection = this.fsh.Schema.PublicLinks;
    this.PublicMap = PublicLinkMask;
  }
}
